import type { color } from '@/shared/styles/assets/colors';
import type { PaletteOptions } from '@mui/material';

type ThemeOption = {
  colors: typeof color;
  heading: string;
  paper: string;
  backgroundDefault: string;
  darkTextPrimary: string;
  darkTextSecondary: string;
  textDark: string;
};

export function themePalette(theme: ThemeOption): PaletteOptions | undefined {
  return {
    mode: 'light',
    common: {
      black: '#000000',
      white: '#ffffff'
    },
    primary: {
      light: theme.colors.primaryLight,
      main: theme.colors.primaryMain,
      dark: theme.colors.primaryDark,
      100: theme.colors.primary100,
      200: theme.colors.primary200,
      300: theme.colors.primary300,
      400: theme.colors.primary400,
      600: theme.colors.primary600,
      800: theme.colors.primary800,
      contrastText: theme.colors.white
    },
    accent: {
      light: theme.colors.accentLight,
      main: theme.colors.accentMain,
      contrastText: theme.colors.white
    },
    secondary: {
      light: theme.colors.secondaryLight,
      main: theme.colors.secondaryMain,
      dark: theme.colors.secondaryDark,
      100: theme.colors.secondary100,
      200: theme.colors.secondary200,
      300: theme.colors.secondary300,
      800: theme.colors.secondary800,
      contrastText: theme.colors.white
    },
    grey: {
      50: theme.colors.grey50,
      100: theme.colors.grey100,
      300: theme.colors.grey300,
      400: theme.colors.grey400,
      500: theme.darkTextSecondary,
      600: theme.heading,
      700: theme.darkTextPrimary,
      900: theme.textDark
    },
    text: {
      primary: theme.darkTextPrimary,
      secondary: theme.darkTextSecondary,
      disabled: theme.colors.grey700
    },
    background: {
      paper: theme.paper,
      default: theme.backgroundDefault
    }
  };
}
